import React from "react"
import { FormattedMessage } from "react-intl"
import { ChevronDown, Filter } from "@walmart-web/livingdesign-icons"
import { Chip } from "@walmart-web/livingdesign-components"
import { default as ButtonLD } from "components/Shared/Button"

interface ButtonProps {
	title: string
	onClick: (e: React.MouseEvent) => void
}

interface PanelButtonsProps {
	cancelTitle: string
	onClickCancel: () => void
	applyTitle: string
	onClickApply: () => void
}

const FilterLabel: React.FC = () => (
	<div className="filters-menu-text">
		<Filter size="small" />
		<FormattedMessage id="phronesis.filters.name.plural" />
	</div>
)

const Button: React.FC<ButtonProps> = ({ title, onClick }) => (
	<Chip
		UNSAFE_className="filters-menu-button"
		onClick={onClick}
		trailing={<ChevronDown />}
	>
		{title}
	</Chip>
)

const PanelButtons: React.FC<PanelButtonsProps> = ({
	cancelTitle,
	onClickCancel,
	applyTitle,
	onClickApply,
}) => (
	<div className="filters-footer">
		<ButtonLD
			role="cancel-link"
			UNSAFE_className="cancel-link"
			variant="tertiary"
			size="medium"
			onClick={() => onClickCancel()}
		>
			{cancelTitle}
		</ButtonLD>
		<ButtonLD
			role="apply-filters"
			size="medium"
			variant="primary"
			onClick={() => onClickApply()}
			UNSAFE_className="apply-filters-button"
		>
			{applyTitle}
		</ButtonLD>
	</div>
)

export { FilterLabel, Button, PanelButtons }
